import { createElement, useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

// Reset and confirmation links carry their token after `#` (#1079): browsers
// never send that part to a server or put it in a Referer.
export function tokenFromHash(hash: string): string | undefined {
  const raw = hash.replace(/^#/, "");
  if (!raw) return undefined;
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

// Read once, when the page opens, and kept in state: the "Skip to content" link
// rewrites the part after `#`, so reading it live would lose the token.
export function useHashToken(): string | undefined {
  const { hash } = useLocation();
  const [token] = useState(() => tokenFromHash(hash));
  return token;
}

// Links sent before #1079 carry the token in the path. Replace the address with
// the `#` form so the rest of the visit has no token in its path or Referers.
export function LegacyTokenRedirect({ to }: { to: string }) {
  const { token } = useParams<{ token: string }>();
  return createElement(Navigate, { to: { pathname: to, hash: token ? `#${token}` : "" }, replace: true });
}
